import React from 'react'
import hbfaLogo from '../assets/hbfa-logo.png'

const Header = ({ onViewChange }) => {
  const apiBase = import.meta.env.VITE_API_BASE || import.meta.env.VITE_API_BASE_URL || ""
  const useMock = import.meta.env.VITE_USE_MOCK === "true"
  const envLabel = useMock
    ? "mock"
    : apiBase.includes("/dev") || apiBase.endsWith("dev")
      ? "dev"
      : apiBase.includes("/prod") || apiBase.endsWith("prod")
        ? "prod"
        : "custom"

  return (
    <header className="header">
      <div className="header-content">
        <button className="header-title" type="button" onClick={() => onViewChange('dashboard')}>
          <img className="header-logo" src={hbfaLogo} alt="HBFA logo" />
          <span>HBFA Unified Platform</span>
          <span className={`env-badge env-${envLabel}`} title={apiBase || "Unknown API base"}>
            {envLabel}
          </span>
        </button>
      </div>
    </header>
  )
}

export default Header
